export const PHOTOS = "photos";
export const LINK_PHOTO = "link-photo";
export const VIDEOS = "videos";
